import { request } from './index';
export const printerUrls = {
	add: '/client/add', //添加分端服务器
	disconnect: '/client/{id}/disconnect', //断开服务器
	reconnect: '/client/{id}/reconnect', //接入服务器
	list: '/client/list',
	clientDateil: '/client/{id}/get',
};
export function addClient(data: IAddSplitEnd) {
	return request(printerUrls.add, { body: data });
}
export function disconnectClient(id: string) {
	return request(`/client/${id}/disconnect`, {}, 'get');
}

export function reconnectClient(id: string, data: IAddSplitEnd) {
	return request(`/client/${id}/reconnect`, { body: data });
}
export function clientList(pagination?: IPagination, name?: string) {
	return request(printerUrls.list, {
		body: name,
		pagination: pagination,
	});
}
export function clientDateil(id: string) {
	return request(`/client/${id}/get`, {}, 'get');
}
export function clientUpdate(id: string, data: ISplitEndUpdate) {
	return request(`/client/${id}/update`, { body: data });
}
